// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  list-style: none;
}

a {
  text-decoration: none;
}

#header-toggle {
  width: 25px;
  margin: 0 auto 15px;
  display: block;
}

:root {
  --header-height: 3rem;
  --nav-width: 70px;
  --first-color: #4723d9;
  --first-color-light: #afa5d9;
  --white-color: #f7f6fb;
  --body-font: "Nunito", sans-serif;
  --normal-font-size: 1rem;
  --z-fixed: 100;
}
*,
::before,
::after {
  box-sizing: border-box;
}
.dashboard {
  position: relative;
  margin: var(--header-height) 0 0 0;
  padding: 0 1rem;
  font-family: var(--body-font);
  font-size: var(--normal-font-size);
  transition: 0.5s;
  
}
a {
  text-decoration: none;
}
.header {
  width: 100%;
  height: var(--header-height);
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 1rem;
  background-color: var(--white-color);
  border: 1px solid #b5b5c3;
  background: #fff;
  z-index: var(--z-fixed);
  transition: 0.5s;
  /* box-shadow: rgba(0, 0, 0, 0.19) 0px 10px 20px, rgba(0, 0, 0, 0.23) 0px 6px 6px;*/
}
.header_toggle {
  color: var(--first-color);
  font-size: 1.5rem;
  cursor: pointer;
  color: #fff;
}
.header_img {
  width: 35px;
  height: 35px;
  display: flex;
  justify-content: center;
  border-radius: 50%;
  overflow: hidden;
}
.header_img img {
  width: 40px;
}
.l-navbar:-webkit-scrollbar {
  width: 50px;
}

.l-navbar:-webkit-scrollbar-track {
  background: #f1f1f1;
}
.l-navbar {
  position: fixed;
  top: 64px;
  left: -30%;
  width: var(--nav-width);
  /* height: 100vh; */
  background-color: var(--first-color);
  border-radius: 0px 15px 0px 0px;
  background: #000000;
  box-shadow: 10px 0px 50px 0px rgba(0, 0, 0, 0.05);
  padding: 0.5rem 1rem 0 0;
  transition: 0.5s;
  z-index: var(--z-fixed);
  margin-top: 15px;
  /* min-height: 530px; */
  max-height: 640px;
  overflow-y: auto;
}
.nav {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  overflow: hidden;
}
.nav_logo,
.nav_link {
  display: grid;
  grid-template-columns: max-content max-content;
  align-items: center;
  column-gap: 1rem;
  padding: 0.5rem 0 0.5rem 1.5rem;
}
.nav_logo {
  margin-bottom: 2rem;
  width: 27%;
}
.nav_logo-icon {
  font-size: 1.25rem;
  color: var(--white-color);
}
.nav_logo-name {
  color: var(--white-color);
  font-weight: 700;
}
.nav_link {
  position: relative;
  color: var(--white-color);
  margin-bottom: 1.5rem;
  transition: 0.3s;
  padding-left: 14px;
  margin-left: 5px;
  border-radius: 4px;
}
.nav_link:hover {
  color: var(--white-color);
}
.nav_icon {
  font-size: 1.25rem;
}
.show {
  left: 0;
}
/*.body-pd {
       padding-left: calc(var(--nav-width) + 1rem)
       }*/
.active {
  color: #f7a600;
  background-color: #fff;
  color: #f7a600;
  
}

.active:hover {
  color: #f7a600;
  background-color: #fff;
  color: #f7a600;
  
}


.height-100 {
  height: 100vh;
}
@media screen and (min-width: 768px) {
  .dashboard {
    margin: calc(var(--header-height) + 1rem) 0 0 0;
    padding-left: calc(var(--nav-width) + 2rem);
  }
  .header {
    height: calc(var(--header-height) + 1rem);
    padding: 0 2rem 0 calc(var(--nav-width) + 2rem);
    padding-left: 0px;
  }
  .header_img {
    width: 40px;
    height: 40px;
  }
  .header_img img {
    width: 45px;
  }
  .l-navbar {
    left: 0;
    padding: 1rem 0rem 0 0;
  }
  .dashboard .l-navbar.show {
    width: calc(var(--nav-width) + 156px);
  }
  .dashboard .l-navbar .show {
    width: calc(var(--nav-width) + 156px);
  }
  .body-pd {
    padding-left: calc(var(--nav-width) + 75px);
  }
}
.ast-sch .input-group {
  border: 1px solid #f3f6f9;
  padding: 3px 10px;
  border-radius: 12px;
  background: #f3f6f9;
}
.ast-sch .input-group input {
  background-color: unset;
  border: none;
  font-family: "Poppins";
  font-style: normal;
  font-weight: 400;
  font-size: 15px;
  line-height: 14px;
  color: #000000;
}
.ast-sch .input-group #button-addon2 {
  border-radius: 25px;
  color: #000000;
  background-color: unset;
  border: none;
}
.ast-sch {
  width: 30%;
}
.wells-ntf {
  width: 70%;
}
.wells-ntf i {
  font-size: 24px;
  color: #cdd2d8;
}
.sltc-imgss {
  position: relative;
  width: 140px;
  top: -6px;
}
.sltc-imgss img {
  position: absolute;
  left: 95px;
  top: 5px;
  width: 28px;
}
.sltc-imgss select.form-select {
  background-color: unset;
  border: none;
  background-image: none;
  position: absolute;
  right: 0px;
  z-index: 99;
  top: 0px;
}
.nav_logo img {
  width: 250px;
  padding-top: 30px;
}
.nav_logo h4 {
  padding-top: 45px;
  color: #212121;
  font-size: 20px;
  font-family: Poppins;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}
.porfile-ntfc {
  width: 22%;
}
.wells-ntf i {
  margin-right: 20px;
}
.ast-sch .input-group input:focus {
  box-shadow: none;
}
.total-box-camp {
  border-radius: 20px;
  padding: 35px 35px;
  position: relative;
  color:#fff;
}
.total-box-camp h4 {
  color: #464e5f;
  font-size: 20px;
  font-family: Poppins;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}
.total-box-camp p {
  color: #b5b5c3;
  font-size: 14px;
  font-family: Poppins;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}
.total-box-camp .cnt-number {
  color: #ef6327;
  text-align: right;
  font-size: 26px;
  font-family: Poppins;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  position: absolute;
  right: 20px;
  top: 14px;
}
.total-box-camp .progress-bar {
  background-color: #f7a600;
}
.prgs-lbl span {
  color: #b5b5c3;
  font-size: 14px;
  font-family: Poppins;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}
.total-box-camp1 h4 {
  color: #fff;
}
.total-box-camp1 .progress-bar {
  background-color: #fff;
}
.buy-box h3 {
  color: #fff;
  font-size: 25px;
  font-family: Poppins;
  font-style: normal;
  font-weight: 700;
}
.buy-box h6 {
  color: #f7a600;
  font-size: 12px;
  font-family: Poppins;
  font-style: normal;
  font-weight: 600;
  border-radius: 4px;
  background: #fff;
  margin-bottom: 0px;
  padding: 8px 5px;
  display: inline-block;
  height: 30px;
  margin-left: 10px;
}
.buy-box {
  margin-bottom: 20px;
}
.total-box-camp1 h5 {
  color: #fff;
  font-size: 15px;
  font-family: Poppins;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  padding-bottom: 15px;
}
.buy-box h2 {
  color: #fff;
  font-size: 12px;
  font-family: Poppins;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  margin-left: 10px;
  padding-top: 10px;
}

.card {
  border: 1px solid #fff;
  padding: 20px 20px;
  border-radius: 12px;
  margin-top: 20px;
}

tbody,
td,
tfoot,
th,
thead,
tr {
  border-color: inherit;
  border-style: solid;
  border-width: 0;
  border-bottom: 1px solid #e5eaee;
  color: #464e5f;
  font-size: 12px;
  font-family: Poppins;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  vertical-align: middle;
}

.table tbody tr td {
  padding: 12px;
}

.table tbody tr td .form-check {
  padding-top: 4px;
}

.btn-veiw {
  color: #f7a600;
  font-size: 12px;
  font-family: Poppins;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  border-radius: 6px;
  background: rgba(247, 166, 0, 0.2);
  padding: 8px 22px;
}

.camping-hd h4 {
  color: #212121;
  font-size: 18px;
  font-family: Poppins;
  font-style: normal;
  font-weight: 500;
  line-height: 21px;
}

.camping-hd p {
  color: #b5b5c3;
  font-size: 12px;
  font-family: Poppins;
  font-style: normal;
  font-weight: 500;
  line-height: 21px;
}

.btn-all {
  border-radius: 6px;
  background: #000000;
  color: #fff;
  font-size: 12px;
  font-family: Poppins;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  width: 140px;
  height: 45px;
  padding: 13px 46px;
}

.campaign-top {
  justify-content: space-between;
}

.white_card {
  background-color: #fff;
  border-radius: 15px;
}

.white_card .nav {
  flex-direction: inherit;
}

.white_card .white_card_header {
  padding: 22px 30px;
}

.box_header {
  display: flex;
  justify-content: space-between;
  margin-bottom: 30px;
  align-items: center;
}

.main-title h3 {
  font-family: mulish, sans-serif;
  font-weight: 700;
  font-size: 18px;
  color: #474d58;
}

.common_tab_btn2 a {
  color: #7e8299;
  font-size: 12px;
  font-weight: 600;
  border-radius: 8px;
  padding: 5px 13px;
}

.common_tab_btn2 a.active {
  color: #fff;
  background-color: #f64e60;
}

.white_card .white_card_body {
  padding: 5px 30px 25px;
}

.apexcharts-canvas {
  position: relative;
  -webkit-user-select: none;
          user-select: none;
}

.apexcharts-tooltip.light {
  border: 1px solid #e3e3e3;
  background: rgba(255, 255, 255, 0.96);
}

.apexcharts-tooltip {
  border-radius: 5px;
  box-shadow: 2px 2px 6px -4px #999;
  cursor: default;
  font-size: 14px;
  left: 62px;
  opacity: 0;
  pointer-events: none;
  position: absolute;
  top: 20px;
  overflow: hidden;
  white-space: nowrap;
  z-index: 12;
  transition: 0.15s ease all;
}

.apexcharts-tooltip.light .apexcharts-tooltip-title {
  background: #eceff1;
  border-bottom: 1px solid #ddd;
}

.apexcharts-tooltip-title {
  padding: 6px;
  font-size: 15px;
  margin-bottom: 4px;
}

.apexcharts-tooltip-series-group.active,
.apexcharts-tooltip-series-group:last-child {
  padding-bottom: 4px;
}

.apexcharts-tooltip-series-group {
  padding: 0 10px;
  display: none;
  text-align: left;
  justify-content: left;
  align-items: center;
}

.apexcharts-tooltip-series-group.active .apexcharts-tooltip-marker {
  opacity: 1;
}

.apexcharts-tooltip-marker {
  width: 12px;
  height: 12px;
  position: relative;
  top: 0px;
  margin-right: 10px;
  border-radius: 50%;
}
.apexcharts-tooltip * {
  font-family: inherit;
}

.apexcharts-tooltip-y-group {
  padding: 6px 0 5px;
}
.apexcharts-tooltip * {
  font-family: inherit;
}

.apexcharts-tooltip-text-value,
.apexcharts-tooltip-text-z-value {
  font-weight: 600;
}

.apexcharts-tooltip-text-value,
.apexcharts-tooltip-text-z-value {
  display: inline-block;
  font-weight: 600;
  margin-left: 5px;
}

.apexcharts-tooltip-text-z-label:empty,
.apexcharts-tooltip-text-z-value:empty {
  display: none;
}
.apexcharts-tooltip-text-z-label:empty,
.apexcharts-tooltip-text-z-value:empty {
  display: none;
}

.apexcharts-tooltip-series-group.active,
.apexcharts-tooltip-series-group:last-child {
  padding-bottom: 4px;
}

.apexcharts-tooltip-series-group {
  padding: 0 10px;
  display: none;
  text-align: left;
  justify-content: left;
  align-items: center;
}

.apexcharts-tooltip-marker {
  width: 12px;
  height: 12px;
  position: relative;
  top: 0px;
  margin-right: 10px;
  border-radius: 50%;
}

.apexcharts-tooltip-y-group {
  padding: 6px 0 5px;
}

.apexcharts-tooltip-text-value,
.apexcharts-tooltip-text-z-value {
  display: inline-block;
  font-weight: 600;
  margin-left: 5px;
}

.Campaign-chart-right h3 {
  color: #212121;
  font-size: 17.895px;
  font-family: Poppins;
  font-style: normal;
  font-weight: 500;
  line-height: 20.877px;
}

.Campaign-chart-right .white_card {
  padding-bottom: 15px;
}

.Campaign-chart-left .white_card {
  padding-bottom: 12px;
}

.richtext select {
  width: 175px;
}

.richtext {
  justify-content: space-between;
  padding: 25px 25px;
  padding-bottom: 0px;
}

/**abmlead**/
.progres-box .progress-bar {
  background-color: #f7a600;
}
.progres-box .progress {
  background: rgba(247, 166, 0, 0.2);
}
.progres-box label {
  color: #b5b5c3;
  font-family: Poppins;
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  position: relative;
  left: 60%;
}
.source-box h3 {
  color: #212121;
  font-family: Poppins;
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  line-height: 21px;
}
.source-top {
  justify-content: space-between;
  margin-bottom: 30px;
}
.filters-box-left ul {
  padding: 0px;
  margin: 0px;
  display: inline-block;
  margin-top: 4px;
}
.filters-box-left ul li {
  float: left;
  font-family: Poppins;
  font-size: 10px;
  font-style: normal;
  font-weight: 500;
  line-height: 21px;
}
.filters-box-left ul li a {
  color: #212121;
  background-color: #fdedcc;
  border-radius: 4px;
  margin-right: 8px;
  padding: 6px 18px;
}
.filters-box {
  justify-content: space-between;
}
.filters-box-left ul li a.active {
  background-color: #fff;
  color: #a1a5b7;
}
.ast-schs .input-group {
  border: 1px solid #fff;
  padding: 3px 2px;
  background: #fff;
  border-radius: 5.345px;
}
.ast-schs .input-group #button-addon2 {
  border-radius: 25px;
  color: #000000;
  background-color: unset;
  border: none;
  padding: 6px;
}
.ast-schs .input-group input {
  background-color: unset;
  border: none;
  font-family: "Poppins";
  font-style: normal;
  font-weight: 400;
  font-size: 15px;
  line-height: 14px;
  color: #000000;
  padding-left: 12px !important;
  padding: 0px;
}
.filters-box-right {
  width: 28%;
}
.btn-clear {
  color: #212121;
  font-family: Poppins;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 21px;
  position: relative;
  top: -12px;
}
.btn-bulk {
  background-color: #000000;
  border-radius: 6px;
  color: #fff;
  font-family: Poppins;
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  padding: 8px 20px;
  display: inline-block;
}
.filters-box-left ul li a i {
  margin-left: 5px;
}
.bnt-liv {
  color: #f7a600;
}

.btn-gradient-primary {
  border-radius: 6px;
  background: #000000;
  color: #fff;
  font-size: 12px;
  font-family: Poppins;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  padding: 12px 40px;
  margin-top: 10px;
  border: 1px solid #000000;
  transition: 0.5s;
}

.forms-sample select {
  appearance: auto;
  padding: 11px 10px;
  border: 1px solid #e5eaee;
  color: #464e5f;
  font-size: 14px;
  font-family: Poppins;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  border-radius: 6px;
}

.forms-sample label {
  color: #212121;
  font-size: 15px;
  font-family: Poppins;
  font-style: normal;
  font-weight: 500;
  line-height: 32px;
}

.forms-sample input {
  border: 1px solid #e5eaee;
  color: #464e5f;
  font-size: 14px;
  font-family: Poppins;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  padding: 11px 10px;
  border-radius: 6px;
}

.forms-sample .form-check .form-check-label {
  display: block;
  margin-left: 1.75rem;
  font-size: 0.875rem;
  line-height: 1.5;
}

.forms-sample .form-check {
  position: relative;
  display: block;
  margin-top: 15px;
  margin-bottom: 20px;
  padding-left: 0;
}
.forms-sample .form-check .form-check-label input {
  position: absolute;
  top: 0;
  left: 0;
  margin-left: 0;
  margin-top: 0;
  z-index: 1;
  cursor: pointer;
  opacity: 0;
  filter: alpha(opacity=0);
}

.form-check .form-check-label input[type="checkbox"] + .input-helper:before,
.form-check .form-check-label input[type="checkbox"] + .input-helper:after {
  position: absolute;
  top: 0;
  left: 0;
}

.form-check .form-check-label input[type="checkbox"] + .input-helper:before {
  content: "";
  width: 18px;
  height: 18px;
  border-radius: 2px;
  border: solid #f7a600;
  border-width: 2px;
  transition: all;
  transition-duration: 0s;
  transition-duration: 250ms;
}

.forms-sample .form-group.row {
  margin-bottom: 15px;
}

.forms-sample .form-label {
  margin-bottom: 0px;
}
`, "",{"version":3,"sources":["webpack://./src/assets/css/style.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,sBAAsB;EACtB,4BAA4B;EAC5B,sBAAsB;EACtB,iCAAiC;EACjC,wBAAwB;EACxB,cAAc;AAChB;AACA;;;EAGE,sBAAsB;AACxB;AACA;EACE,kBAAkB;EAClB,kCAAkC;EAClC,eAAe;EACf,6BAA6B;EAC7B,kCAAkC;EAClC,gBAAgB;;AAElB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,WAAW;EACX,4BAA4B;EAC5B,eAAe;EACf,MAAM;EACN,OAAO;EACP,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,oCAAoC;EACpC,yBAAyB;EACzB,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAChB,mFAAmF;AACrF;AACA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,eAAe;EACf,WAAW;AACb;AACA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,SAAS;EACT,UAAU;EACV,uBAAuB;EACvB,mBAAmB;EACnB,oCAAoC;EACpC,+BAA+B;EAC/B,mBAAmB;EACnB,iDAAiD;EACjD,wBAAwB;EACxB,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAChB,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,gBAAgB;AAClB;AACA;;EAEE,aAAa;EACb,8CAA8C;EAC9C,mBAAmB;EACnB,gBAAgB;EAChB,+BAA+B;AACjC;AACA;EACE,mBAAmB;EACnB,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,yBAAyB;AAC3B;AACA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,kBAAkB;AACpB;AACA;EACE,OAAO;AACT;AACA;;SAES;AACT;EACE,cAAc;EACd,sBAAsB;EACtB,cAAc;;AAEhB;;AAEA;EACE,cAAc;EACd,sBAAsB;EACtB,cAAc;;AAEhB;;;AAGA;EACE,aAAa;AACf;AACA;EACE;IACE,+CAA+C;IAC/C,2CAA2C;EAC7C;EACA;IACE,yCAAyC;IACzC,+CAA+C;IAC/C,iBAAiB;EACnB;EACA;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,WAAW;EACb;EACA;IACE,OAAO;IACP,sBAAsB;EACxB;EACA;IACE,qCAAqC;EACvC;EACA;IACE,qCAAqC;EACvC;EACA;IACE,2CAA2C;EAC7C;AACF;AACA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,uBAAuB;EACvB,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,cAAc;EACd,uBAAuB;EACvB,YAAY;AACd;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;EACE,eAAe;EACf,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,SAAS;AACX;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,WAAW;AACb;AACA;EACE,uBAAuB;EACvB,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,QAAQ;AACV;AACA;EACE,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,UAAU;AACZ;AACA;EACE,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,SAAS;AACX;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,WAAW;AACb;AACA;EACE,sBAAsB;AACxB;AACA;EACE,WAAW;EACX,eAAe;EACf,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,eAAe;EACf,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,oBAAoB;AACtB;AACA;EACE,WAAW;EACX,eAAe;EACf,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;;;;;;EAME,qBAAqB;EACrB,mBAAmB;EACnB,eAAe;EACf,gCAAgC;EAChC,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,kCAAkC;EAClC,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,sBAAsB;EAGtB,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;EAC/B,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,qCAAqC;AACvC;;AAEA;EACE,kBAAkB;EAClB,iCAAiC;EACjC,eAAe;EACf,eAAe;EACf,UAAU;EACV,UAAU;EACV,oBAAoB;EACpB,kBAAkB;EAClB,SAAS;EACT,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;EACX,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,kBAAkB;AACpB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,QAAQ;EACR,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;AACpB;AACA;EACE,oBAAoB;AACtB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;;EAEE,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;;EAEE,aAAa;AACf;AACA;;EAEE,aAAa;AACf;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,QAAQ;EACR,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,8BAA8B;EAC9B,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA,YAAY;AACZ;EACE,yBAAyB;AAC3B;AACA;EACE,kCAAkC;AACpC;AACA;EACE,cAAc;EACd,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,SAAS;AACX;AACA;EACE,cAAc;EACd,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,8BAA8B;EAC9B,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,WAAW;EACX,qBAAqB;EACrB,eAAe;AACjB;AACA;EACE,WAAW;EACX,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;AACnB;AACA;EACE,8BAA8B;AAChC;AACA;EACE,sBAAsB;EACtB,cAAc;AAChB;AACA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;AACxB;AACA;EACE,mBAAmB;EACnB,cAAc;EACd,uBAAuB;EACvB,YAAY;EACZ,YAAY;AACd;AACA;EACE,uBAAuB;EACvB,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,6BAA6B;EAC7B,YAAY;AACd;AACA;EACE,UAAU;AACZ;AACA;EACE,cAAc;EACd,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,WAAW;EACX,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,qBAAqB;AACvB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,cAAc;EACd,aAAa;EACb,UAAU;EACV,eAAe;EACf,UAAU;EACV,wBAAwB;AAC1B;;AAEA;;EAEE,kBAAkB;EAClB,MAAM;EACN,OAAO;AACT;;AAEA;EACE,WAAW;EACX,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qBAAqB;EACrB,iBAAiB;EAEjB,eAAe;EACf,uBAAuB;EAEvB,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB","sourcesContent":["* {\r\n  margin: 0;\r\n  padding: 0;\r\n  box-sizing: border-box;\r\n  list-style: none;\r\n}\r\n\r\na {\r\n  text-decoration: none;\r\n}\r\n\r\n#header-toggle {\r\n  width: 25px;\r\n  margin: 0 auto 15px;\r\n  display: block;\r\n}\r\n\r\n:root {\r\n  --header-height: 3rem;\r\n  --nav-width: 70px;\r\n  --first-color: #4723d9;\r\n  --first-color-light: #afa5d9;\r\n  --white-color: #f7f6fb;\r\n  --body-font: \"Nunito\", sans-serif;\r\n  --normal-font-size: 1rem;\r\n  --z-fixed: 100;\r\n}\r\n*,\r\n::before,\r\n::after {\r\n  box-sizing: border-box;\r\n}\r\n.dashboard {\r\n  position: relative;\r\n  margin: var(--header-height) 0 0 0;\r\n  padding: 0 1rem;\r\n  font-family: var(--body-font);\r\n  font-size: var(--normal-font-size);\r\n  transition: 0.5s;\r\n  \r\n}\r\na {\r\n  text-decoration: none;\r\n}\r\n.header {\r\n  width: 100%;\r\n  height: var(--header-height);\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  padding: 0 1rem;\r\n  background-color: var(--white-color);\r\n  border: 1px solid #b5b5c3;\r\n  background: #fff;\r\n  z-index: var(--z-fixed);\r\n  transition: 0.5s;\r\n  /* box-shadow: rgba(0, 0, 0, 0.19) 0px 10px 20px, rgba(0, 0, 0, 0.23) 0px 6px 6px;*/\r\n}\r\n.header_toggle {\r\n  color: var(--first-color);\r\n  font-size: 1.5rem;\r\n  cursor: pointer;\r\n  color: #fff;\r\n}\r\n.header_img {\r\n  width: 35px;\r\n  height: 35px;\r\n  display: flex;\r\n  justify-content: center;\r\n  border-radius: 50%;\r\n  overflow: hidden;\r\n}\r\n.header_img img {\r\n  width: 40px;\r\n}\r\n.l-navbar:-webkit-scrollbar {\r\n  width: 50px;\r\n}\r\n\r\n.l-navbar:-webkit-scrollbar-track {\r\n  background: #f1f1f1;\r\n}\r\n.l-navbar {\r\n  position: fixed;\r\n  top: 64px;\r\n  left: -30%;\r\n  width: var(--nav-width);\r\n  /* height: 100vh; */\r\n  background-color: var(--first-color);\r\n  border-radius: 0px 15px 0px 0px;\r\n  background: #000000;\r\n  box-shadow: 10px 0px 50px 0px rgba(0, 0, 0, 0.05);\r\n  padding: 0.5rem 1rem 0 0;\r\n  transition: 0.5s;\r\n  z-index: var(--z-fixed);\r\n  margin-top: 15px;\r\n  /* min-height: 530px; */\r\n  max-height: 640px;\r\n  overflow-y: auto;\r\n}\r\n.nav {\r\n  height: 100%;\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: space-between;\r\n  overflow: hidden;\r\n}\r\n.nav_logo,\r\n.nav_link {\r\n  display: grid;\r\n  grid-template-columns: max-content max-content;\r\n  align-items: center;\r\n  column-gap: 1rem;\r\n  padding: 0.5rem 0 0.5rem 1.5rem;\r\n}\r\n.nav_logo {\r\n  margin-bottom: 2rem;\r\n  width: 27%;\r\n}\r\n.nav_logo-icon {\r\n  font-size: 1.25rem;\r\n  color: var(--white-color);\r\n}\r\n.nav_logo-name {\r\n  color: var(--white-color);\r\n  font-weight: 700;\r\n}\r\n.nav_link {\r\n  position: relative;\r\n  color: var(--white-color);\r\n  margin-bottom: 1.5rem;\r\n  transition: 0.3s;\r\n  padding-left: 14px;\r\n  margin-left: 5px;\r\n  border-radius: 4px;\r\n}\r\n.nav_link:hover {\r\n  color: var(--white-color);\r\n}\r\n.nav_icon {\r\n  font-size: 1.25rem;\r\n}\r\n.show {\r\n  left: 0;\r\n}\r\n/*.body-pd {\r\n       padding-left: calc(var(--nav-width) + 1rem)\r\n       }*/\r\n.active {\r\n  color: #f7a600;\r\n  background-color: #fff;\r\n  color: #f7a600;\r\n  \r\n}\r\n\r\n.active:hover {\r\n  color: #f7a600;\r\n  background-color: #fff;\r\n  color: #f7a600;\r\n  \r\n}\r\n\r\n\r\n.height-100 {\r\n  height: 100vh;\r\n}\r\n@media screen and (min-width: 768px) {\r\n  .dashboard {\r\n    margin: calc(var(--header-height) + 1rem) 0 0 0;\r\n    padding-left: calc(var(--nav-width) + 2rem);\r\n  }\r\n  .header {\r\n    height: calc(var(--header-height) + 1rem);\r\n    padding: 0 2rem 0 calc(var(--nav-width) + 2rem);\r\n    padding-left: 0px;\r\n  }\r\n  .header_img {\r\n    width: 40px;\r\n    height: 40px;\r\n  }\r\n  .header_img img {\r\n    width: 45px;\r\n  }\r\n  .l-navbar {\r\n    left: 0;\r\n    padding: 1rem 0rem 0 0;\r\n  }\r\n  .dashboard .l-navbar.show {\r\n    width: calc(var(--nav-width) + 156px);\r\n  }\r\n  .dashboard .l-navbar .show {\r\n    width: calc(var(--nav-width) + 156px);\r\n  }\r\n  .body-pd {\r\n    padding-left: calc(var(--nav-width) + 75px);\r\n  }\r\n}\r\n.ast-sch .input-group {\r\n  border: 1px solid #f3f6f9;\r\n  padding: 3px 10px;\r\n  border-radius: 12px;\r\n  background: #f3f6f9;\r\n}\r\n.ast-sch .input-group input {\r\n  background-color: unset;\r\n  border: none;\r\n  font-family: \"Poppins\";\r\n  font-style: normal;\r\n  font-weight: 400;\r\n  font-size: 15px;\r\n  line-height: 14px;\r\n  color: #000000;\r\n}\r\n.ast-sch .input-group #button-addon2 {\r\n  border-radius: 25px;\r\n  color: #000000;\r\n  background-color: unset;\r\n  border: none;\r\n}\r\n.ast-sch {\r\n  width: 30%;\r\n}\r\n.wells-ntf {\r\n  width: 70%;\r\n}\r\n.wells-ntf i {\r\n  font-size: 24px;\r\n  color: #cdd2d8;\r\n}\r\n.sltc-imgss {\r\n  position: relative;\r\n  width: 140px;\r\n  top: -6px;\r\n}\r\n.sltc-imgss img {\r\n  position: absolute;\r\n  left: 95px;\r\n  top: 5px;\r\n  width: 28px;\r\n}\r\n.sltc-imgss select.form-select {\r\n  background-color: unset;\r\n  border: none;\r\n  background-image: none;\r\n  position: absolute;\r\n  right: 0px;\r\n  z-index: 99;\r\n  top: 0px;\r\n}\r\n.nav_logo img {\r\n  width: 250px;\r\n  padding-top: 30px;\r\n}\r\n.nav_logo h4 {\r\n  padding-top: 45px;\r\n  color: #212121;\r\n  font-size: 20px;\r\n  font-family: Poppins;\r\n  font-style: normal;\r\n  font-weight: 500;\r\n  line-height: normal;\r\n}\r\n.porfile-ntfc {\r\n  width: 22%;\r\n}\r\n.wells-ntf i {\r\n  margin-right: 20px;\r\n}\r\n.ast-sch .input-group input:focus {\r\n  box-shadow: none;\r\n}\r\n.total-box-camp {\r\n  border-radius: 20px;\r\n  padding: 35px 35px;\r\n  position: relative;\r\n  color:#fff;\r\n}\r\n.total-box-camp h4 {\r\n  color: #464e5f;\r\n  font-size: 20px;\r\n  font-family: Poppins;\r\n  font-style: normal;\r\n  font-weight: 600;\r\n  line-height: normal;\r\n}\r\n.total-box-camp p {\r\n  color: #b5b5c3;\r\n  font-size: 14px;\r\n  font-family: Poppins;\r\n  font-style: normal;\r\n  font-weight: 500;\r\n  line-height: normal;\r\n}\r\n.total-box-camp .cnt-number {\r\n  color: #ef6327;\r\n  text-align: right;\r\n  font-size: 26px;\r\n  font-family: Poppins;\r\n  font-style: normal;\r\n  font-weight: 700;\r\n  line-height: normal;\r\n  position: absolute;\r\n  right: 20px;\r\n  top: 14px;\r\n}\r\n.total-box-camp .progress-bar {\r\n  background-color: #f7a600;\r\n}\r\n.prgs-lbl span {\r\n  color: #b5b5c3;\r\n  font-size: 14px;\r\n  font-family: Poppins;\r\n  font-style: normal;\r\n  font-weight: 600;\r\n  line-height: normal;\r\n}\r\n.total-box-camp1 h4 {\r\n  color: #fff;\r\n}\r\n.total-box-camp1 .progress-bar {\r\n  background-color: #fff;\r\n}\r\n.buy-box h3 {\r\n  color: #fff;\r\n  font-size: 25px;\r\n  font-family: Poppins;\r\n  font-style: normal;\r\n  font-weight: 700;\r\n}\r\n.buy-box h6 {\r\n  color: #f7a600;\r\n  font-size: 12px;\r\n  font-family: Poppins;\r\n  font-style: normal;\r\n  font-weight: 600;\r\n  border-radius: 4px;\r\n  background: #fff;\r\n  margin-bottom: 0px;\r\n  padding: 8px 5px;\r\n  display: inline-block;\r\n  height: 30px;\r\n  margin-left: 10px;\r\n}\r\n.buy-box {\r\n  margin-bottom: 20px;\r\n}\r\n.total-box-camp1 h5 {\r\n  color: #fff;\r\n  font-size: 15px;\r\n  font-family: Poppins;\r\n  font-style: normal;\r\n  font-weight: 600;\r\n  line-height: normal;\r\n  padding-bottom: 15px;\r\n}\r\n.buy-box h2 {\r\n  color: #fff;\r\n  font-size: 12px;\r\n  font-family: Poppins;\r\n  font-style: normal;\r\n  font-weight: 600;\r\n  line-height: normal;\r\n  margin-left: 10px;\r\n  padding-top: 10px;\r\n}\r\n\r\n.card {\r\n  border: 1px solid #fff;\r\n  padding: 20px 20px;\r\n  border-radius: 12px;\r\n  margin-top: 20px;\r\n}\r\n\r\ntbody,\r\ntd,\r\ntfoot,\r\nth,\r\nthead,\r\ntr {\r\n  border-color: inherit;\r\n  border-style: solid;\r\n  border-width: 0;\r\n  border-bottom: 1px solid #e5eaee;\r\n  color: #464e5f;\r\n  font-size: 12px;\r\n  font-family: Poppins;\r\n  font-style: normal;\r\n  font-weight: 600;\r\n  line-height: normal;\r\n  vertical-align: middle;\r\n}\r\n\r\n.table tbody tr td {\r\n  padding: 12px;\r\n}\r\n\r\n.table tbody tr td .form-check {\r\n  padding-top: 4px;\r\n}\r\n\r\n.btn-veiw {\r\n  color: #f7a600;\r\n  font-size: 12px;\r\n  font-family: Poppins;\r\n  font-style: normal;\r\n  font-weight: 600;\r\n  line-height: normal;\r\n  border-radius: 6px;\r\n  background: rgba(247, 166, 0, 0.2);\r\n  padding: 8px 22px;\r\n}\r\n\r\n.camping-hd h4 {\r\n  color: #212121;\r\n  font-size: 18px;\r\n  font-family: Poppins;\r\n  font-style: normal;\r\n  font-weight: 500;\r\n  line-height: 21px;\r\n}\r\n\r\n.camping-hd p {\r\n  color: #b5b5c3;\r\n  font-size: 12px;\r\n  font-family: Poppins;\r\n  font-style: normal;\r\n  font-weight: 500;\r\n  line-height: 21px;\r\n}\r\n\r\n.btn-all {\r\n  border-radius: 6px;\r\n  background: #000000;\r\n  color: #fff;\r\n  font-size: 12px;\r\n  font-family: Poppins;\r\n  font-style: normal;\r\n  font-weight: 600;\r\n  line-height: normal;\r\n  width: 140px;\r\n  height: 45px;\r\n  padding: 13px 46px;\r\n}\r\n\r\n.campaign-top {\r\n  justify-content: space-between;\r\n}\r\n\r\n.white_card {\r\n  background-color: #fff;\r\n  -webkit-border-radius: 15px;\r\n  -moz-border-radius: 15px;\r\n  border-radius: 15px;\r\n}\r\n\r\n.white_card .nav {\r\n  flex-direction: inherit;\r\n}\r\n\r\n.white_card .white_card_header {\r\n  padding: 22px 30px;\r\n}\r\n\r\n.box_header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  margin-bottom: 30px;\r\n  align-items: center;\r\n}\r\n\r\n.main-title h3 {\r\n  font-family: mulish, sans-serif;\r\n  font-weight: 700;\r\n  font-size: 18px;\r\n  color: #474d58;\r\n}\r\n\r\n.common_tab_btn2 a {\r\n  color: #7e8299;\r\n  font-size: 12px;\r\n  font-weight: 600;\r\n  border-radius: 8px;\r\n  padding: 5px 13px;\r\n}\r\n\r\n.common_tab_btn2 a.active {\r\n  color: #fff;\r\n  background-color: #f64e60;\r\n}\r\n\r\n.white_card .white_card_body {\r\n  padding: 5px 30px 25px;\r\n}\r\n\r\n.apexcharts-canvas {\r\n  position: relative;\r\n  user-select: none;\r\n}\r\n\r\n.apexcharts-tooltip.light {\r\n  border: 1px solid #e3e3e3;\r\n  background: rgba(255, 255, 255, 0.96);\r\n}\r\n\r\n.apexcharts-tooltip {\r\n  border-radius: 5px;\r\n  box-shadow: 2px 2px 6px -4px #999;\r\n  cursor: default;\r\n  font-size: 14px;\r\n  left: 62px;\r\n  opacity: 0;\r\n  pointer-events: none;\r\n  position: absolute;\r\n  top: 20px;\r\n  overflow: hidden;\r\n  white-space: nowrap;\r\n  z-index: 12;\r\n  transition: 0.15s ease all;\r\n}\r\n\r\n.apexcharts-tooltip.light .apexcharts-tooltip-title {\r\n  background: #eceff1;\r\n  border-bottom: 1px solid #ddd;\r\n}\r\n\r\n.apexcharts-tooltip-title {\r\n  padding: 6px;\r\n  font-size: 15px;\r\n  margin-bottom: 4px;\r\n}\r\n\r\n.apexcharts-tooltip-series-group.active,\r\n.apexcharts-tooltip-series-group:last-child {\r\n  padding-bottom: 4px;\r\n}\r\n\r\n.apexcharts-tooltip-series-group {\r\n  padding: 0 10px;\r\n  display: none;\r\n  text-align: left;\r\n  justify-content: left;\r\n  align-items: center;\r\n}\r\n\r\n.apexcharts-tooltip-series-group.active .apexcharts-tooltip-marker {\r\n  opacity: 1;\r\n}\r\n\r\n.apexcharts-tooltip-marker {\r\n  width: 12px;\r\n  height: 12px;\r\n  position: relative;\r\n  top: 0px;\r\n  margin-right: 10px;\r\n  border-radius: 50%;\r\n}\r\n.apexcharts-tooltip * {\r\n  font-family: inherit;\r\n}\r\n\r\n.apexcharts-tooltip-y-group {\r\n  padding: 6px 0 5px;\r\n}\r\n.apexcharts-tooltip * {\r\n  font-family: inherit;\r\n}\r\n\r\n.apexcharts-tooltip-text-value,\r\n.apexcharts-tooltip-text-z-value {\r\n  font-weight: 600;\r\n}\r\n\r\n.apexcharts-tooltip-text-value,\r\n.apexcharts-tooltip-text-z-value {\r\n  display: inline-block;\r\n  font-weight: 600;\r\n  margin-left: 5px;\r\n}\r\n\r\n.apexcharts-tooltip-text-z-label:empty,\r\n.apexcharts-tooltip-text-z-value:empty {\r\n  display: none;\r\n}\r\n.apexcharts-tooltip-text-z-label:empty,\r\n.apexcharts-tooltip-text-z-value:empty {\r\n  display: none;\r\n}\r\n\r\n.apexcharts-tooltip-series-group.active,\r\n.apexcharts-tooltip-series-group:last-child {\r\n  padding-bottom: 4px;\r\n}\r\n\r\n.apexcharts-tooltip-series-group {\r\n  padding: 0 10px;\r\n  display: none;\r\n  text-align: left;\r\n  justify-content: left;\r\n  align-items: center;\r\n}\r\n\r\n.apexcharts-tooltip-marker {\r\n  width: 12px;\r\n  height: 12px;\r\n  position: relative;\r\n  top: 0px;\r\n  margin-right: 10px;\r\n  border-radius: 50%;\r\n}\r\n\r\n.apexcharts-tooltip-y-group {\r\n  padding: 6px 0 5px;\r\n}\r\n\r\n.apexcharts-tooltip-text-value,\r\n.apexcharts-tooltip-text-z-value {\r\n  display: inline-block;\r\n  font-weight: 600;\r\n  margin-left: 5px;\r\n}\r\n\r\n.Campaign-chart-right h3 {\r\n  color: #212121;\r\n  font-size: 17.895px;\r\n  font-family: Poppins;\r\n  font-style: normal;\r\n  font-weight: 500;\r\n  line-height: 20.877px;\r\n}\r\n\r\n.Campaign-chart-right .white_card {\r\n  padding-bottom: 15px;\r\n}\r\n\r\n.Campaign-chart-left .white_card {\r\n  padding-bottom: 12px;\r\n}\r\n\r\n.richtext select {\r\n  width: 175px;\r\n}\r\n\r\n.richtext {\r\n  justify-content: space-between;\r\n  padding: 25px 25px;\r\n  padding-bottom: 0px;\r\n}\r\n\r\n/**abmlead**/\r\n.progres-box .progress-bar {\r\n  background-color: #f7a600;\r\n}\r\n.progres-box .progress {\r\n  background: rgba(247, 166, 0, 0.2);\r\n}\r\n.progres-box label {\r\n  color: #b5b5c3;\r\n  font-family: Poppins;\r\n  font-size: 12px;\r\n  font-style: normal;\r\n  font-weight: 600;\r\n  line-height: normal;\r\n  position: relative;\r\n  left: 60%;\r\n}\r\n.source-box h3 {\r\n  color: #212121;\r\n  font-family: Poppins;\r\n  font-size: 18px;\r\n  font-style: normal;\r\n  font-weight: 500;\r\n  line-height: 21px;\r\n}\r\n.source-top {\r\n  justify-content: space-between;\r\n  margin-bottom: 30px;\r\n}\r\n.filters-box-left ul {\r\n  padding: 0px;\r\n  margin: 0px;\r\n  display: inline-block;\r\n  margin-top: 4px;\r\n}\r\n.filters-box-left ul li {\r\n  float: left;\r\n  font-family: Poppins;\r\n  font-size: 10px;\r\n  font-style: normal;\r\n  font-weight: 500;\r\n  line-height: 21px;\r\n}\r\n.filters-box-left ul li a {\r\n  color: #212121;\r\n  background-color: #fdedcc;\r\n  border-radius: 4px;\r\n  margin-right: 8px;\r\n  padding: 6px 18px;\r\n}\r\n.filters-box {\r\n  justify-content: space-between;\r\n}\r\n.filters-box-left ul li a.active {\r\n  background-color: #fff;\r\n  color: #a1a5b7;\r\n}\r\n.ast-schs .input-group {\r\n  border: 1px solid #fff;\r\n  padding: 3px 2px;\r\n  background: #fff;\r\n  border-radius: 5.345px;\r\n}\r\n.ast-schs .input-group #button-addon2 {\r\n  border-radius: 25px;\r\n  color: #000000;\r\n  background-color: unset;\r\n  border: none;\r\n  padding: 6px;\r\n}\r\n.ast-schs .input-group input {\r\n  background-color: unset;\r\n  border: none;\r\n  font-family: \"Poppins\";\r\n  font-style: normal;\r\n  font-weight: 400;\r\n  font-size: 15px;\r\n  line-height: 14px;\r\n  color: #000000;\r\n  padding-left: 12px !important;\r\n  padding: 0px;\r\n}\r\n.filters-box-right {\r\n  width: 28%;\r\n}\r\n.btn-clear {\r\n  color: #212121;\r\n  font-family: Poppins;\r\n  font-size: 12px;\r\n  font-style: normal;\r\n  font-weight: 500;\r\n  line-height: 21px;\r\n  position: relative;\r\n  top: -12px;\r\n}\r\n.btn-bulk {\r\n  background-color: #000000;\r\n  border-radius: 6px;\r\n  color: #fff;\r\n  font-family: Poppins;\r\n  font-size: 12px;\r\n  font-style: normal;\r\n  font-weight: 600;\r\n  line-height: normal;\r\n  padding: 8px 20px;\r\n  display: inline-block;\r\n}\r\n.filters-box-left ul li a i {\r\n  margin-left: 5px;\r\n}\r\n.bnt-liv {\r\n  color: #f7a600;\r\n}\r\n\r\n.btn-gradient-primary {\r\n  border-radius: 6px;\r\n  background: #000000;\r\n  color: #fff;\r\n  font-size: 12px;\r\n  font-family: Poppins;\r\n  font-style: normal;\r\n  font-weight: 600;\r\n  line-height: normal;\r\n  padding: 12px 40px;\r\n  margin-top: 10px;\r\n  border: 1px solid #000000;\r\n  transition: 0.5s;\r\n}\r\n\r\n.forms-sample select {\r\n  appearance: auto;\r\n  padding: 11px 10px;\r\n  border: 1px solid #e5eaee;\r\n  color: #464e5f;\r\n  font-size: 14px;\r\n  font-family: Poppins;\r\n  font-style: normal;\r\n  font-weight: 500;\r\n  line-height: normal;\r\n  border-radius: 6px;\r\n}\r\n\r\n.forms-sample label {\r\n  color: #212121;\r\n  font-size: 15px;\r\n  font-family: Poppins;\r\n  font-style: normal;\r\n  font-weight: 500;\r\n  line-height: 32px;\r\n}\r\n\r\n.forms-sample input {\r\n  border: 1px solid #e5eaee;\r\n  color: #464e5f;\r\n  font-size: 14px;\r\n  font-family: Poppins;\r\n  font-style: normal;\r\n  font-weight: 500;\r\n  line-height: normal;\r\n  padding: 11px 10px;\r\n  border-radius: 6px;\r\n}\r\n\r\n.forms-sample .form-check .form-check-label {\r\n  display: block;\r\n  margin-left: 1.75rem;\r\n  font-size: 0.875rem;\r\n  line-height: 1.5;\r\n}\r\n\r\n.forms-sample .form-check {\r\n  position: relative;\r\n  display: block;\r\n  margin-top: 15px;\r\n  margin-bottom: 20px;\r\n  padding-left: 0;\r\n}\r\n.forms-sample .form-check .form-check-label input {\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n  margin-left: 0;\r\n  margin-top: 0;\r\n  z-index: 1;\r\n  cursor: pointer;\r\n  opacity: 0;\r\n  filter: alpha(opacity=0);\r\n}\r\n\r\n.form-check .form-check-label input[type=\"checkbox\"] + .input-helper:before,\r\n.form-check .form-check-label input[type=\"checkbox\"] + .input-helper:after {\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n}\r\n\r\n.form-check .form-check-label input[type=\"checkbox\"] + .input-helper:before {\r\n  content: \"\";\r\n  width: 18px;\r\n  height: 18px;\r\n  border-radius: 2px;\r\n  border: solid #f7a600;\r\n  border-width: 2px;\r\n  -webkit-transition: all;\r\n  transition: all;\r\n  transition-duration: 0s;\r\n  -webkit-transition-duration: 250ms;\r\n  transition-duration: 250ms;\r\n}\r\n\r\n.forms-sample .form-group.row {\r\n  margin-bottom: 15px;\r\n}\r\n\r\n.forms-sample .form-label {\r\n  margin-bottom: 0px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
